// Vuex Client module mutations
export const FILL_LIST = 'FILL_LIST';
